'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessagesIcon = function MessagesIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M14.64,24.76 L9.7,24.76 L6.57,26.8 C5.91,27.22 5.55,26.96 5.77,26.2 L6.44,23.85 C4.97,22.87 4,21.19 4,19.27 C4,17.66 4.69,16.21 5.8,15.2 C6.53,18.46 9.43,20.9 12.89,20.9 L18.6,20.9 L19.6,21.55 C18.74,23.44 16.84,24.76 14.64,24.76 L14.64,24.76 L14.64,24.76 Z M20.49,19.45 L13.99,19.45 C10.03,19.45 6.82,16.21 6.82,12.22 C6.82,8.23 10.03,5 13.99,5 L20.83,5 C24.79,5 28,8.23 28,12.22 C28,14.74 26.72,16.96 24.78,18.25 L25.79,21.78 C26.01,22.53 25.65,22.8 25,22.37 L20.49,19.45 L20.49,19.45 L20.49,19.45 Z' })
  );
};

MessagesIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = MessagesIcon;